// extracted by mini-css-extract-plugin
export default {"yzy-launch-container":"Allocation_yzy-launch-container__uyork","yzy-text-container":"Allocation_yzy-text-container__hWQ+F"};